<template>
  <div>
    <condition-part
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasDate="true"
      :hasEatType="true"
      :hasStore="true"
      :hasTerminal="true"
      :hasEmployee="true"
      :hasCostType="true"
      :hasFood="false"
      :hasFoodKind="false"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["daystatistic", "simple"],
      reportType: "daystatistic",
    };
  },
  components: {
    conditionPart,
  },
  computed: {
    columns() {
      if (this.reportType == "simple") {
        return [
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "TradeType" },
          { name: "SalNumber" },
          { name: "SalTime" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "Total" },
          { name: "CreditCardPrice" },
          { name: "CreditCardPayType" },
          { name: "AuthCode" },
          { name: "CardNumber" },
          { name: "CreditCardTradeNumber" },
        ];
      } else if (this.reportType == "daystatistic") {
        return [
          { name: "BusinessDay" },
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "Total" },
          { name: "CreditCardPrice" },
          { name: "EasyCardPrice" },
          { name: "iPASSPrice" },
          { name: "LinePayPrice" },
          { name: "JKOPayPrice" },
          { name: "TWPayPrice" },
          { name: "PiWalletPrice" },
          { name: "EasyWalletPrice" },
        ];
      }
    },
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getCreditCard(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getCreditCard(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printCreditCard(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;
      const vm = this;
      this.$api.reports.getCreditCard(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
